{
  "hero": {
    "title": "NAPAICP 說明中心",
    "description": "搜尋操作問題，或依照角色快速完成任務。"
  },
  "search": {
    "placeholder": "搜尋操作問題、功能名稱或錯誤訊息",
    "submit": "搜尋",
    "resultsHeading": "搜尋結果",
    "resultsFor": "「{{query}}」的搜尋結果",
    "resultCount": "共 {{count}} 筆結果",
    "clearFilters": "清除篩選",
    "filters": {
      "role": "角色",
      "roleAll": "全部",
      "type": "類型"
    },
    "type": {
      "how-to": "操作指南",
      "troubleshooting": "疑難排解",
      "reference": "參考資料",
      "tutorial": "教學",
      "explanation": "說明",
      "guide": "操作手冊",
      "howto": "快速開始"
    },
    "noResults": {
      "heading": "找不到「{{query}}」的結果",
      "suggestion1": "改用較短關鍵字",
      "suggestion2": "搜尋畫面上的按鈕名稱",
      "suggestion3": "搜尋完整錯誤訊息",
      "suggestion4": "查看目前角色的常用操作"
    },
    "autocomplete": {
      "groupTasks": "操作",
      "groupTroubleshooting": "疑難排解",
      "groupGuide": "角色手冊"
    }
  },
  "gettingStarted": {
    "heading": "第一次使用 NAPAICP？",
    "description": "從註冊帳號到完成第一個任務，幾分鐘內快速上手。"
  },
  "roles": {
    "heading": "我要做什麼？",
    "student": "參賽者",
    "judge": "評審",
    "organizer": "主辦方",
    "admin": "平台管理"
  },
  "home": {
    "browseByType": "或依類型瀏覽"
  },
  "tasks": {
    "heading": "常用操作",
    "headingForRole": "{{role}}常用任務"
  },
  "troubleshooting": {
    "heading": "遇到問題？",
    "cta": "查看所有疑難排解"
  },
  "workflow": {
    "heading": "完整任務清單",
    "categories": {
      "account": "帳號",
      "registration": "報名",
      "team": "隊伍",
      "submission": "作品繳交",
      "judging": "評審",
      "judge-management": "評審管理",
      "setup": "競賽建立與設定",
      "results": "晉級與結果",
      "platform": "平台治理",
      "reference": "參考資料",
      "operations": "競賽營運",
      "people-management": "人員管理",
      "events": "活動平台"
    }
  },
  "article": {
    "roleLabel": "適用角色",
    "estimatedMinutes": "預估時間",
    "estimatedMinutesValue": "約 {{count}} 分鐘",
    "lastVerified": "最後驗證",
    "verified": "已驗證",
    "warningHeading": "警告",
    "prerequisitesHeading": "操作前確認",
    "diagramAltText": "狀態轉換流程圖",
    "stepsHeading": "操作步驟",
    "afterwardHeading": "完成後",
    "nextStepsHeading": "下一步",
    "faqHeading": "常見問題",
    "relatedHeading": "相關文件",
    "guideLinkCta": "了解此功能的完整規則",
    "symptomHeading": "症狀",
    "causesHeading": "最常見原因",
    "diagnosisHeading": "排查方式",
    "resolutionHeading": "正常結果",
    "stillStuckHeading": "仍無法解決",
    "doNotProvideHeading": "請勿提供",
    "figuresHeading": "畫面範例",
    "figuresNote": "畫面為示範資料，姓名、人數與時間僅供說明，不代表實際內容。"
  },
  "nav": {
    "breadcrumbHome": "首頁",
    "breadcrumbHelp": "說明中心"
  },
  "feedback": {
    "prompt": "這篇文章對您有幫助嗎？",
    "yes": "有幫助",
    "no": "沒有幫助",
    "commentLabel": "還有想補充的嗎？（選填）",
    "commentPlaceholder": "告訴我們可以怎麼改進這篇文章",
    "submit": "送出意見",
    "submitting": "送出中…",
    "thanks": "謝謝您的回饋！",
    "error": "送出時發生問題，請稍後再試一次。"
  }
}
